export const arrayBufferToBase64 = buffer => {
  return new Promise(resolve => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    resolve(window.btoa(binary));
  });
};

export const base64ToBlob = (base64, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const getFileNameFromResponse = (res, defaultName = "export.xlsx") => {
  const contentDisposition = res.headers["content-disposition"];
  if (contentDisposition) {
    const match = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (match && match[1]) {
      return match[1].replace(/['"]/g, "");
    }
  }
  return defaultName;
};

export const downloadFileFromRes = res => {
  const fileName = getFileNameFromResponse(res);
  const url = window.URL.createObjectURL(new Blob([res?.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
export default {
  arrayBufferToBase64,
  base64ToBlob,
  getFileNameFromResponse,
  downloadFileFromRes,
};
